import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

const SELECTION_API_SUPPORTED_TYPES = ['text', 'search', 'tel', 'url', 'password'];

@Directive({
  selector: '[appLowercaseNoSpaces]',
})
export class LowercaseNoSpacesDirective {

  constructor(private ngControl: NgControl) { }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const original = input.value;
    const sanitized = original.toLowerCase().replace(/\s/g, '');
    if (original === sanitized) return;

    const caret = input.selectionStart ?? sanitized.length;
    const newCaret = original.slice(0, caret).replace(/\s/g, '').length;

    this.ngControl.control?.setValue(sanitized);

    if (SELECTION_API_SUPPORTED_TYPES.includes(input.type)) {
      input.setSelectionRange(newCaret, newCaret);
    }
  }
}
